export default __webpack_public_path__ + "images/U3.27b6cba.png";